import script from "./ProcessSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcessSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProcessSection.vue?vue&type=style&index=0&id=122feb71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122feb71"]])

export default __exports__